import isWeb from './isWeb';

let isJRApp = false;

if (isWeb) {
    const ua = (navigator && navigator.userAgent) || '';
    isJRApp = /application=JDJR-App/.test(ua);
}

export default isJRApp;
